<template>
  <vx-list 
    class="yunxiao teacher class-details"
    :api="api"
    :params="queryParams"
    @load="onLoad"
    ref="vxList"
    firstShowLoading
    enable>
    <div class="class-info-box">
      <div class="class-info" :class="{'sports':companyInfo.companyProduct.productPackage==3,'completed': classInfo.classStatus === 1 }">
        <span
          v-if="moreOperationCctions.length"
          class="edit-nav"
          data-test="class-details-btn-operation"
          @click="showMoreOperation = true"
        >
          <van-icon class="icon" name="bars" />操作
        </span>
        <div class="til">
          <span v-if="classInfo.classStatus === 1">【已结班】</span>
          <!-- <span class="charge-type-tag" v-if="classInfo.chargeType === 2">天</span> -->
          {{ classInfo.className }}
        </div>
        <div class="line">
          教学课程：
          <x3-tag-day v-if="classInfo.chargeType == 2"></x3-tag-day>
          <span v-if="classInfo.curriculumName"> {{ classInfo.curriculumName }}</span>
          <span v-else> 课程未设置 </span>
        </div>

        <div class="line">
          所属校区：<span>{{ classInfo.campusName || '未设置' }}</span>
        </div>
        <div class="line">
          上课老师：<span>{{attendClassTeachersText}}</span>
        </div>
        <transition-group name="van-fade">
          <div class="line" v-show="!folded" key="1">
            助&emsp;&emsp;教：<span>{{assistantTeacherText}}</span> 
          </div>
          <div class="line" v-if="classInfo.planOpenClassTime" v-show="!folded" key="2">
            开课时间：<span>{{ classInfo.planOpenClassTime | formatDatetime('M月d日') }}</span>
          </div>
          <div class="line" v-else v-show="!folded" key="3">开课时间：<span>未设置</span></div>
          <div class="line class-time-period" v-show="!folded" key="4">
            <span class="label-name">上课时段：</span>
            <span>{{ formateClassTime }}</span>
          </div>
          <div class="line class-time-period" v-show="!folded" key="5">
            <span class="label-name">备&emsp;&emsp;注：</span>
            <span>{{ classInfo.remark || '未设置'}}</span>
          </div>
          <!-- <div v-show="!folded" key="5">
            <div
              class="line two-colum"
              key="6"
              v-if="app.tool.safeReadObjProp(classInfo, 'classPriceItems.0.id')"
            >
              课程价格：
              <div class="price-list-wrapper">
                <span v-for="priceItem of classInfo.classPriceItems" :key="priceItem.id"
                  >￥{{ priceItem.price }}包含{{ priceItem.priceNum
                  }}{{ priceItem.priceUnitName }}</span
                >
              </div>
            </div>
            <div class="line" v-else key="7">课程价格：<span>未设置</span></div>
          </div> -->
        </transition-group>
        <div
          class="fold-div"
          :class="{ folded: folded }"
          data-test="class-details-btn-folded"
          @click.stop="folded = !folded"
        >
          <van-icon class="icon" name="arrow-up" />
        </div>
      </div>
      <div
        class="photo-box-wrap flex-between"
        v-if="classInfo.classStatus !== 1"
        data-test="class-details-btn-student"
        @click="gotoClassStudent"
      >
        <div class="photo-box">
          <template v-for="(item, index) in classInfo.studentVoList">
            <div class="photo-nav" v-if="index < 3" :key="item.id">
              {{ (item.name || '-').substr(-2) }}
            </div> </template
          ><span v-if="classInfo.studentVoList && classInfo.studentVoList.length > 3">等</span>
          {{ classInfo.currentClassNum || 0 }}个学员
        </div>
        <span class="flex-center" style="color: var(--c1)">
          管理学员
          <van-icon class="icon" name="arrow" size="16" color="var(--c1)" style="margin-top:-1px"/>
        </span>
      </div>
      <div class="op-paike flex-between">
        班级排课
        <div class="flex-center" v-if="classInfo.classStatus === 0">
          <div
            class="add-btn more"
            style="margin-right: calc(var(--gap)*4)"
            v-if="
              this.list &&
              this.list.length &&
              app.permission.op('edit_course_arrange || delete_course_arrange')
            "
            @click="toMultiEdit"
            data-test="class-details-btn-multi-edit"
          >
            批量编辑
          </div>
          <div
            class="add-btn"
            @click="addPaike"
            data-test="class-details-btn-paike-add"
            v-if="app.permission.op('add_course_arrange')"
          >
            <van-icon name="plus" />
            &nbsp;
            <div class="add-btn__text">新增排课</div>
          </div>
        </div>
      </div>
      <div class="top" v-show="paikeInfo.totalArrange">
        总排课{{ paikeInfo.totalArrange || 0 }}｜未点名排课
        {{ paikeInfo.noRollCallArrange || 0 }}｜最后排课截止
        {{ paikeInfo.stopCourseDate || '' }}
      </div>
      <search-filter-new @change="filterChange">
        <filter-item
          :class="{'has-filter': !params.isDesc }"
          keyName="isDesc"
          :value="params.isDesc"
          kind="yq-通用单选"
          :list="[
            { text: '按日期倒序', value: true },
            { text: '按日期升序', value: false },
          ]"
        >
          <template #default>排序方式</template>
        </filter-item>
        <filter-item
          :class="{'has-filter': params.status !== null }"        
          keyName="status"
          :value="params.status"
          kind="yq-通用单选"
          :list="[
            { text: '全部', value: null },
            { text: '未点名', value: 0 },
            { text: '已点名', value: 1 },
          ]"
        >       
          <template #default>点名状态</template>
        </filter-item>
      </search-filter-new>
    </div>

    <div class="class-paike">
      <div
        v-for="item in list"
        class="course-card"
        :key="item.id"
        :time-out="item.timeOut"
        :class="{ 'is-cancel': item.courseStatus == 2 }"
        @click="gotoCourseArrange(item.id)"
      >
        <div class="left">
          <div class="l1 normal reserve-status" :class="{ 'is-late': item.endTime <= Date.now() }">
            <div class="is-reserve" v-if="item.enableReserve">约</div>
            {{ item.startTime | formatDatetime('yyyy-MM-dd') }}（{{ item.startTime | getWeek }}）
          </div>
          <div class="l2 van-ellipsis">
            时间：{{ item.startTime | formatDatetime('hh:mm') }}～{{
              item.endTime | formatDatetime('hh:mm')
            }}
            · {{ item.courseAmount }}{{lessonUnit}}
          </div>
          <div class="l2 van-ellipsis" v-if="getTeachersName(item.courseArrangeTeacherVoList)">
            老师：{{ getTeachersName(item.courseArrangeTeacherVoList)||'-' }}
          </div>
          <div
            class="l2 van-ellipsis"
            v-if="getTeachersName(item.courseArrangeTeacherVoList, true)"
          >
            助教：{{ getTeachersName(item.courseArrangeTeacherVoList, true)||'-' }}
          </div>
          <div class="l2 van-ellipsis" v-if="item.classRoomName">
            教室：{{ item.classRoomName }}
          </div>
          <div class="l2 van-ellipsis" v-if="item.courseContent">
            上课内容：{{ item.courseContent }}
          </div>
        </div>
        <div class="right">
          <van-button
            size="small"
            type="primary"
            class="gray-button"
            square round
            v-if="item.courseStatus == 2"
          >
            已取消
          </van-button>
          <van-button
            size="small"
            type="primary"
            v-if="item.courseStatus !== 2 && app.permission.op('update_course_sign')"
            square round
            :class="{ 'gray-button': item.signNum == item.signTotalNum && item.courseStatus == 1 }"
            @click.stop="gotoCourseArrange(item.id)"
          >
            {{ item.courseStatus == 0 ? '去点名' : '已点名' }}
          </van-button>
          <div class="status" v-if="item.courseStatus != 2">
            {{ item.signNum }}/{{ item.signTotalNum }}
          </div>
        </div>
      </div>

      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        v-if="list.length === 0 && !loading"
        image-size="128"
        style="padding-top: 30px; color: var(--g6)"
      >
        <div class="empty-tips">班级暂无排课~</div>
      </van-empty>
    </div>

    <!-- <page-footer-btn multipleBtns v-if="classInfo.classStatus === 0">
        <van-button
          square round
          block
          @click="toMultiEdit"
          v-if="this.list && this.list.length"
        >
          批量编辑
        </van-button>
        <van-button square round block type="primary" @click="addPaike">
          新增排课
        </van-button>
    </page-footer-btn> -->
    <van-action-sheet
      v-model="showMoreOperation"
      :actions="moreOperationCctions"
      cancel-text="取消"
      close-on-click-action
      @cancel="showMoreOperation = false"
      @select="onSelectOperation"
    />
  </vx-list>
</template>

<script>
import emptyPage from '@teacher/components/empty-page.vue';
import x3TagDay from '@x3/common/tag/x3-tag-day.vue';
// import ClassPaikeList from "./class-paike-list.vue";
// import classStudentList from "./class-student-list.vue";
// import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import FilterItem from '@x3/vue/comp/filter-item.vue';
import { getPaikePeriod } from '@x3/vue/filters/filters.js';

export default {
  name: 'classDetail',
  components: {
    emptyPage,
    x3TagDay,
    SearchFilterNew,
    FilterItem,
    // ClassPaikeList,
    // classStudentList,
    // pageFooterBtn,
  },
  data() {
    return {
      pageTitle: '班级详情',
      classId: this.$vxRoute.params.classId,
      classInfo: {},
      curPaike: '',
      folded: true,
      params: {
        isDesc: true,
        status: null,
      },
      paikeInfo: {},
      list: [],
      loading: false,
      showMoreOperation: false,
      api: this.$api.getArrangeList,
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit','companyInfo']),
    attendClassTeachersText: function () {
      let attendClassTeachers = this.classInfo.attendClassTeachers || [];
      let tcs = attendClassTeachers.filter(v=>v.teacherRule === 0).map(v=>v.teacherName);
      if (tcs.length) {
        return tcs.join("、");
      // } else if (tcs.length > 1) {
      } else {
        return `未设置`
      }
    },
    assistantTeacherText () {
      let attendClassTeachers = this.classInfo.attendClassTeachers || [];
      let cpc = attendClassTeachers.filter(v=>v.teacherRule === 1).map(v=>v.teacherName);
      if (cpc.length) {
        return cpc.join("、");
      } else {
        return `未设置`
      }
    },
    haveUnSignClass() {
      let arr = this.list.filter(v => v.allSign != 1 && v.courseStatus != 2);
      return Boolean(arr.length);
    },
    formateClassTime() {
      let c = this.classInfo || {};
      let c2 = getPaikePeriod(c.classTimeVoList || []);
      return c2 ? c2 : '未设置';
    },
    moreOperationCctions() {
      let actions = [];
      if (this.classInfo.classStatus === 1) {
        if (app.permission.op('close_class')) {
          actions.push({ name: '撤销结班', id: 4 });
        }
      } else {
        if (app.permission.op('edit_class')) {
          actions.push({ name: '编辑班级', id: 1 });
        }
        if (app.permission.op('close_class')) {
          actions.push({ name: '结班', id: 2 });
        }
        if (app.permission.op('delete_class')) {
          actions.push({ name: '删除班级', id: 3, color: 'var(--c3)' });
        }
      }

      return actions;
    },
    queryParams () {
      return {
        classId: this.classId,
        ...this.params,
      }
    }
  },
  methods: {
    onLoad(list, res) {
      vant.Toast.clear();
      this.paikeInfo = res.data;
      let cclist = res.data && res.data.courseArrangeExtendVoList;
      if (res.page && res.page.pageNum == 1) {
        this.list = cclist || []
      } else {
        Array.isArray(cclist) && this.list.push(...cclist);
      }
    },
    filterChange(obj){
      Object.assign(this.params, obj);
      app.ls.setStorage('class-detail-sort', obj.isDesc);
      // this.getArrangeList();
    },
    getTeachersName (teahcers, isAssistant) {
      let list = teahcers || [];
      let role = isAssistant?1:0;
      return list.filter(v=>v.teacherRule===role).map(v=>v.teacherName).join("、")
    },
    // 获取班级信息
    async getClassInfo() {
      let res = await this.$api.getClassInfoVo({
        classId: this.classId,
      });
      if (res.code == 200) {
        if (res.data.courseArrangeVoList) {
          res.data.courseArrangeVoList.some(item => {
            if (item.timeOut == 0 && item.courseStatus != 2) {
              this.curPaike = item.id;
              return true;
            }
          });
        }
        this.classInfo = res.data;
      } else if (res.code === 830000010) {
        this.$dialog
          .alert({
            message: '班级已被删除',
            confirmButtonText: '返回',
          })
          .then(() => {
            this.$router.back();
          });
      }
    },
    gotoEdit() {
      this.$router.push('/baseClassAdd?id=' + this.classId);
    },
    gotoClassStudent() {
      let { campusId, campusName } = this.classInfo;
      this.$router.push(
        `/classStudentList/${this.classId}?campusId=${campusId}&campusName=${campusName}`
      );
    },
    // 查看排课详情
    gotoCourseArrange(id) {
      this.$router.push(`/courseArrange/${id}`);
    },
    // 新增排课
    addPaike() {
      this.showLoading();
      this.$api
        .campusCheckEnabled({
          campusId: this.classInfo.campusId,
        })
        .then(res => {
          vant.Toast.clear();
          if (res.code === 200 && !res.data) {
            vant.Dialog.alert({
              title: '提示',
              message: '班级归属的校区已停用，不能进行该操作',
              confirmButtonText: '知道啦',
            });
          } else {
            this.$router.push(`/classPaiKeAdd?classId=${this.classId}&fromClass=1`);
          }
        })
        .catch(() => {
          vant.Toast.clear();
        });
    },
    // 批量编辑
    toMultiEdit() {
      this.$router.push(
        `/classMultiEdit/${this.classId}?cid=` + (this.list[0] && this.list[0].campusId)
      );
    },
    onSelectOperation(val) {
      switch (val.id) {
        case 1:
          this.gotoEdit();
          break;
        case 2:
          this.classCompletion();
          break;
        case 3:
          this.deleteClass();
          break;
        case 4:
          this.classCancleCompletion();
          break;
        default:
          break;
      }
    },
    classCompletion() {
      // if (this.haveUnSignClass) {
      //   this.$dialog.alert({
      //     message: '班级存在未点名排课，请完成点名或删除排课后再进行结班操作',
      //     confirmButtonText: '我知道了',
      //   });
      //   return false;
      // }
      this.$dialog.confirm({
        message: '结班后，全部学员将被移出班级，未点名排课将被取消，并且不能再对此班级排课。</br>请确认是否结班？',
        messageAlign:'left',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      })
      .then(() => {
        this.showLoading();
        this.$api.classCompletion({
          classId: this.classId,
        }).then(res => {
          // 班级已经上回商城
          this.$toast.clear();
          if (res.code === 830000013) {
            this.$dialog.confirm({
              message: '班级已经在线上商城上架，请前往商城下架班级再进行结班',
              confirmButtonText: '去下架',
              cancelButtonText: '取消',
            }).then(() => {
              this.$router.push('/mallProductList');
            }).catch(() => {
              console.log('取消操作');
            });
            return false;
          }
          if (res.code === 200) {
            // this.classInfo.classStatus = 1;
            this.refreshAll();
            app.vue.$emit('refresh-class-list');
            /* v3.6 停卡去除的功能 */
            // if (res.data.length) {
            //   this.$toast.clear();
            //   app.ls.set('endClassZeroCourseFeeStudent', res.data);
            //   this.$router.push(
            //     `/class/end-student-card/${this.classId}?n=${this.classInfo.className}`
            //   );
            //   return false;
            // }
            // this.$toast.success('操作成功');
            this.$toast.clear();
            if (app.permission.op('become_history')) { // 是否有转曾就读权限
              this.$api.classStudentFindClassStudent({
                classId: this.classId,
                inOut: 2
              }).then(res => {
                this.$toast.clear();
                if (res.code == 200) {
                  let canTransfer = [];
                  canTransfer = res.data && res.data.filter(v => v.student.status === 1);
                  if (canTransfer.length > 0) {
                    this.$dialog.confirm({
                      message: '结班成功。</br>是否需要将历史学员转为曾就读？',
                      messageAlign:'left',
                      confirmButtonText: '去转曾就读',
                      cancelButtonText: '取消',
                    }).then(() => {
                      this.$router.push('/classHistoryStudents?cid='+ this.classId+'&editMode=true');
                    });
                  } else {
                    setTimeout(()=> {
                      this.$toast.success('结班成功');
                    }, 300);
                  }
                }
                if (res.code > 60000) {
                  app.http.tipErr(res.msg || '网络异常，请稍后重试');
                  return res;
                }
                return res;
              })
            } else {
              setTimeout(()=> {
                this.$toast.success('结班成功');
              }, 300);
            }
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        });
      }).catch(err => {
        console.log(err);
      });
    },
    classCancleCompletion() {
      this.$dialog
        .confirm({
          title: '是否确认撤销结班？',
          message:
            '撤销结班，班级将恢复至正常状态，可重新加入学员、对班级进行排课。 <br><span style="font-size: var(--fs-sm);">（已出班学员可在班级历史学员中快捷加回班级）</span>',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          allowHtml: true,
          messageAlign: 'left',
        })
        .then(() => {
          this.showLoading();
          this.$api
            .cancelClassCompletion({
              classId: this.classId,
            })
            .then(async res => {
              // 班级已经上回商城
              this.$toast.clear();

              if (res.code === 200) {
                this.classInfo.classStatus = 0;
                app.vue.$emit('refresh-class-list');
                this.$toast.success('撤销结班成功');

                const res = await this.$api.simpleInfoBatch({ids: this.classInfo.attendClassTeachers.map(item=>item.teacherId)});
                if (res.data.some(item=>item.status == 0)) {
                  vant.Dialog.alert({
                    message: '原上课老师或助教已离职，请及时分配新的老师或助教。'
                  })
                }

              }
              if (res.code > 60000) {
                this.$toast.fail(res.msg || '网络异常，请稍后重试');
              }
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteClass() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '班级删除后将不可使用及恢复，是否确定删除班级？',
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          confirmButtonColor: 'var(--c3)',
        })
        .then(() => {
          this.$api
            .classDelete({
              classId: this.classId,
            })
            .then(res => {
              this.$toast.clear();
              if (res.code === 830000013) {
                this.$dialog
                  .confirm({
                    message: '班级已经在线上商城上架，请前往商城下架班级再进行结班',
                    confirmButtonText: '去下架',
                    cancelButtonText: '取消',
                  })
                  .then(() => {
                    this.$router.push('/mallProductList');
                  })
                  .catch(() => {
                    console.log('取消操作');
                  });
                return false;
              }
              if (res.code === 200) {
                this.$toast.success('删除成功');
                app.vue.$emit('refresh-class-list');
                this.$router.back();
                return false;
              }

              if (res.code > 60000) this.$toast.fail(res.msg);
            });
        })
        .catch(() => {});
    },
    refreshAll() {
      this.getClassInfo();
      this.$refs['vxList'] && this.$refs['vxList'].hightReFresh();
    }
    /* v3.6 停卡  发现这段代码一直没有被使用 */
    // toEndStudentCards() {
    //   this.showLoading();
    //   this.$api
    //     .findZeroCourseFeeStudent({
    //       classId: this.classId,
    //     })
    //     .then(res => {
    //       if (res.code === 200) {
    //         if (res.data.length) {
    //           this.$toast.clear();
    //           this.$router('/class/end-student-card/' + this.classId);
    //           return false;
    //         }
    //         this.$toast.success('操作成功');
    //       }
    //       if (res.code > 60000) {
    //         this.$toast.fail(res.msg || '网络异常，请稍后重试');
    //       }
    //     });
    // },
  },
  created() {
    try {
      const desc = app.ls.getStorage('class-detail-sort');
      this.params.isDesc = desc === undefined ? true : desc;
    } catch(e) {

    }
    this.getClassInfo();
    this.$onBus('class-paike-add-success', this.refreshAll);
    this.$onBus('refresh-classStudentList', this.refreshAll);
    this.$onBus('refresh-multi-edit-page', this.refreshAll);
  },
  beforeDestroy() {
    vant.Toast.clear();
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.class-details {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .icon,
  .vxs-icon {
    font-size: var(--fs-lg);
  }
  .class-info-box {
    padding: calc(var(--gap) * 16);
    padding-bottom: 0;
    background-color: var(--white);
    .class-info {
      position: relative;
      padding: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 42);
      margin-bottom: calc(var(--gap) * 16);
      color: var(--white);
      border-radius: var(--radius-sm);
      background: linear-gradient(136deg, #18b1ff 0%, #2389ff 100%);
      // background: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/course-bk1.png')
      //     bottom right/135px 73px no-repeat,
      //   linear-gradient(136deg, #18b1ff 0%, #2389ff 100%);
      .til {
        padding-right: 68px;
        font-weight: var(--bold);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        word-break: break-all;
        // .charge-type-tag {
        //   display: inline-block;
        //   margin-right: calc(var(--gap) * 4);
        //   font-size: var(--fs-sm);
        //   line-height: var(--lh-sm);
        //   padding: calc(var(--gap) * 1) calc(var(--gap) * 4);
        //   border-radius: 2px;
        //   white-space: nowrap;
        //   color: var(--white);
        //   background:var(--c2);
        //   vertical-align: top;
        // }
      }
      .line {
        margin-top: calc(var(--gap) * 8);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: rgba(var(--white-rgb), 0.6);
        &.two-colum {
          display: flex;
        }
        .price-list-wrapper > span {
          display: block;
        }
      }
      .class-time-period {
        display: flex;
        .label-name {
          white-space: nowrap;
        }
      }
      .edit-nav {
        position: absolute;
        top: calc(var(--gap) * 16);
        right: calc(var(--gap) * 16);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        color: var(--white);
        .van-icon-bars {
          margin-right: 2px;
        }
      }
      .fold-div {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        width: 100%;
        bottom: 0;
        left: 0;
        &.folded {
          .icon {
            transform: rotateZ(180deg);
          }
        }
      }
      &.sports {
        background: linear-gradient(136deg, #B2A8FF 0%, #8070F5 100%);
      }
      &.completed {
        background: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/course-bk2.png')
            bottom right/135px 73px no-repeat,
          linear-gradient(313deg, #c3cace 0%, #a1a3a6 100%);
        .til {
          color: var(--white);
        }
      }
    }
    .photo-box-wrap {
      margin-bottom: calc(var(--gap) * 16);
      color: var(--g6);
      background-color: var(--g1);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      border-radius: var(--radius-sm);
      .photo-box {
        display: flex;
        align-items: center;
        .photo-nav {
          display: flex;
          align-items: center;
          justify-content: center;
          width: calc(var(--w) * 32);
          height: calc(var(--w) * 32);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--white);
          background-color: var(--c1);
          border-radius: 50%;
          border: unset;
          outline: unset;
          margin-right: calc(var(--gap) * 4);
        }
      }
    }
    .op-paike {
      padding: calc(var(--gap) * 8) 0;
      font-weight: var(--bold);
      .edit-btn {
        margin-right: 10px;
        padding: calc(var(--gap) * 8) calc(var(--gap) * 12);
        border-radius: 999px;
        background: var(--g1);
        color: var(--g8);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        font-weight: var(--bold);
      }
    }
    .top {
      display: flex;
      align-items: center;
      color: var(--g6);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
    }
  }
  .class-paike {
    background-color: var(--g1);
    margin-top: calc(var(--gap) * 12);
    padding: 0 calc(var(--gap) * 16);
  }

  .course-card {
    .reserve-status{
      display: flex;
      align-items: center;
      .is-reserve{
        display: flex;        
        align-items: center;
        justify-content: center;
        margin-right: calc(var(--gap) * 8);
        height: calc(var(--w) * 20);
        font-size:var(--fs-sm);
        width: calc(var(--w) * 20);
        min-width: calc(var(--w) * 20);
        border-radius: var(--radius-base);
        background-color: var(--c2);
        color: var(--white);
      }
      .l1{
        flex: 1;
      }
    }
    .l2{
      display: block;
    }
  }
}
</style>